import {Button, Card, CardBody, CardHeader, Col, Row, Container} from "reactstrap";
import React, { useCallback, useEffect, useMemo, useState } from "react"
import TableContainer from "../../Components/Common/TableContainerReactTable";
import DeleteModal from "../../Components/Common/DeleteModal";
import { useDispatch, useSelector } from "react-redux";
import { addCatalog, deletedCatalog, getCatalogs, getDescendants, updateCatalog } from "../../slices/catalogs/thunk";
import { navigate } from "atoms/BreadCrumb";
import { Link } from "react-router-dom";
import ModalCreate from "pages/Catalog/components/modalCreate";
import CommonBreadCrumb from "../../Components/Common/BreadCrumb";

const Spinner = ({ isLoading }: { isLoading: boolean }) => (
  isLoading ? (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 9999,
      }}
    >
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  ) : null
)

const formDefaultStructure: Object[] = [
  {
    "key": "name",
    "title": "Nombre",
    "placeHolder": "Ingrese el nombre del catálogo",
    "type": "text",
    "validators": {
      "required": true,
    },
    'column': 6
  },
  {
    "key": "priority",
    "title": "Prioridad",
    "placeHolder": "Ingrese la prioridad del catálogo",
    "type": "number",
    "validators": {
      "required": true,
    },
    'column': 6
  }
];

const defaultLevel = { id: '0', name: 'Inicio', structure: formDefaultStructure }

function createArrayFromText(text: string): string[] {
  return text.split(",").map(item => item.trim());
}

const Catalogs = () => {
  document.title = "Catálogos | Vuelo";
  const dispatch: any = useDispatch();
  const [levels, setLevels] = useState<navigate[]>([defaultLevel])
  const [currentCatalog, setCurrentCatalog] = useState<navigate>(defaultLevel)
  const [openModalCreate, setOpenModalCreate] = useState<boolean>(false)
  const [childForm, setChildForm] = useState<any>([])
  const [isUpdate, setIsUpdate] = useState<boolean>(false)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [filesUpload, setFilesUpload] = useState<any>(null)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [deleteModal, setDeleteModal] = useState<boolean>(false)
  const [selectedRecordId, setSelectedRecordId] = useState<string | null>(null)

  const saveFiles = (data: any) => {
    setFilesUpload(data)
  }

  const actions: any = {
    saveFiles
  }

  useEffect(() => {
    dispatch(getCatalogs())
  }, [dispatch])

  useEffect(() => {
    if (!openModalCreate) {
      setChildForm([]);
      setFilesUpload(null);
    }
  }, [openModalCreate, setFilesUpload]);

  const catalog = useSelector((state: any) => state.Catalogs.catalogList)
  const descendants = useSelector((state: any) => state.Catalogs.descendants)

  const getDisplayData = () => {
    if (levels.length === 1) {
      return catalog;
    }
    const currentLevel = levels[levels.length - 1];
    return descendants[currentLevel.id] || [];
  }

  const onSubmit = async ({ name, priority, ...addicionalData }: any) => {
    setIsLoading(true)
    
    try {
      if (addicionalData.categories) {
        addicionalData.categories = createArrayFromText(addicionalData.categories)
      }

      const catalogData: any = {
        name,
        priority: Number(priority),
        jsonData: {
          data: addicionalData,
          structure: childForm
        }
      };

      if (!isUpdate && currentCatalog.id !== '0') {
        catalogData.parent = currentCatalog.id;
      }

      if (isUpdate) {
        catalogData.id = currentCatalog.id;
      }

      const catalog = catalogData;

      setOpenModalCreate(false)
      await dispatch(isUpdate ? updateCatalog({ catalog, idCatalog: currentCatalog.id }) : addCatalog(catalog))
    } catch (error) {
      console.error('Error al guardar catálogo:', error)
    } finally {
      setIsLoading(false)
    }
  }

  //Get children data
  const handleGetDataDescendants = useCallback(async (levels: any) => {
    setIsLoading(true)
    setLevels(levels)
    setCurrentCatalog(levels[levels.length - 1])
    await dispatch(levels[levels.length - 1].id !== '0' ? getDescendants(levels[levels.length - 1].id) : getCatalogs())
    setIsLoading(false)
  }, [dispatch])

  const handledDeletedCatalog = async (id: string) => {
    setIsLoading(true)
    await dispatch(deletedCatalog(id))
    await dispatch(getCatalogs())
    setIsLoading(false)

  }

  const confirmDelete = async () => {
    if (selectedRecordId) {
      await handledDeletedCatalog(selectedRecordId)
    }
    setDeleteModal(false)
    setSelectedRecordId(null)
  }

  const cols = useMemo(
    () => [
      {
        header: "id",
        accessorKey: "id",
        enableColumnFilter: false,

      },

      {
        header: "Nombre",
        accessorKey: "name",
        enableColumnFilter: false,
        cell: (cell: any) => {
          return <React.Fragment>
            <Link to="#" onClick={() => {
                const { id, name, priority, jsonData } = cell.row.original
                handleGetDataDescendants([...levels, {
                  id,
                  name,
                  priority,
                  data: { ...jsonData.data },
                  structure: [...formDefaultStructure, ...(jsonData.structure || [])]
                }]);
              }}>
              {cell.row.original.name}
            </Link>
            </React.Fragment>;
        },
      },
      {
        header: "Prioridad",
        accessorKey: "priority",
        enableColumnFilter: false,
      },
      {
        header: "Acciónes",
        enableColumnFilter: false,
        cell: (cell: any) => {
          return <React.Fragment>

            <div className="d-flex flex-row-reverse">
              <div className="flex-grow-1 tasks_name"></div>
              <div className="flex-shrink-0 ms-4">
                <ul className="list-inline">

                  <div className="d-flex gap-2">
                    <Button
                        color="warning"
                        size="sm"
                        title="Editar"
                        onClick={() => {
                          const { id, name, priority, jsonData }: any = { ...cell.row.original };
                          let json = { ...jsonData.data };

                          if (jsonData.data?.categories) {
                            const categories = jsonData.data.categories.map((item: string) => ({
                              label: item,
                              value: item,
                            }));
                            json = { ...jsonData.data, categories };
                          }

                          const catalog = { id, name, priority, ...json };

                          setFilesUpload(null);
                          setChildForm(jsonData.structure || []);

                          setCurrentCatalog({
                            id,
                            name,
                            structure: currentCatalog.structure.map((item: any) => ({
                              ...item,
                              value: catalog[item.key],
                            })),
                          });

                          setOpenModalCreate(true);
                          setIsUpdate(true);
                        }}
                    >
                      <i className="ri-pencil-line"></i>
                    </Button>

                    <Button
                        color="danger"
                        size="sm"
                        title="Eliminar"
                        onClick={() => {
                          const rolData = { ...cell.row.original };
                          setSelectedRecordId(rolData.id)
                          setDeleteModal(true)
                        }}
                    >
                      <i className="ri-delete-bin-line"></i>
                    </Button>

                  </div>

                </ul>
              </div>
            </div>
            </React.Fragment>;
        },

      },

    ],
    [handleGetDataDescendants, levels, currentCatalog.structure, setFilesUpload]
  );


  return (<React.Fragment>
      <Spinner isLoading={isLoading}/>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={confirmDelete}
        onCloseClick={() => setDeleteModal(false)}
        recordId={selectedRecordId}
      />
      <div className="page-content">
            <CommonBreadCrumb title="Catálogos" pageTitle="Inicio" />
          <Container fluid>
        <Row>
          <Col>
            <Card>
              <CardHeader className="d-flex justify-content-between align-items-center">
                  <h5 className="card-title mb-0">Catálogos</h5>
                  <Button color="primary" onClick={() => {
                        setCurrentCatalog(levels[levels.length - 1])
                          setIsUpdate(false)
                          setOpenModalCreate(true)
                        }}
                              disabled={isLoading}>
                    <i className="ri-add-line align-bottom me-1"></i> Agregar
                  </Button>
              </CardHeader>
                <CardBody>
                    <div className="min-w-[1000px]">
                        <TableContainer
                            columns={cols}
                            data={getDisplayData()}
                            isGlobalFilter={true}
                            customPageSize={10}
                            theadClass="table-light text-muted"
                            SearchPlaceholder="Buscar por nombre, correo o rol..."
                            divClass="table-responsive table-card mb-1"
                            tableClass="align-middle table-nowrap"
                        />
                    </div>
                </CardBody>
            </Card>
          </Col>
        </Row>
        </Container>
      </div>
        <ModalCreate
            key={currentCatalog.id + (isUpdate ? '-update' : '-create')}
            show={openModalCreate}
            setOpenModal={setOpenModalCreate}
            onSubmit={onSubmit}
            currentCatalog={currentCatalog}
            setChildForm={setChildForm}
            childForm={childForm}
            isUpdate={isUpdate}
            callback={actions}
        />
      </React.Fragment>
  );

}
export default Catalogs;
